import { Component, OnDestroy, OnInit } from '@angular/core';
import {
  StateService,
  ToolService,
  WorkDay,
  ConstructionSite,
  TimeEntry,
  RouterService,
  WorkingEntry,
} from 'projects/shared/src/public-api';
import { ActivatedRoute } from '@angular/router';
import { Subscription } from 'rxjs';
import { ModalController } from '@ionic/angular';

@Component({
  selector: 'lib-hours-form',
  templateUrl: './hours-form.component.html',
  styleUrls: ['./hours-form.component.scss'],
  standalone: false,
})
export class HoursFormComponent implements OnInit, OnDestroy {
  constructor(
    public state: StateService,

    public tools: ToolService,
    private route: ActivatedRoute,
    public routerService: RouterService,
    public modalCtrl: ModalController
  ) {}

  subs: Subscription[] = [];
  workDayId: string;
  newWorkDay: WorkDay = {};
  conSites: ConstructionSite[];
  workers: string[] = [];
  usersWithExistingWorkDays: string[] = [];
  fullDayWorked: string;

  ngOnInit() {
    if (this.workDayId != null) {
      this.subs.push(
        this.state.workingDays$.subscribe((x) => {
          this.newWorkDay = x.find((y) => y.id == this.workDayId);
          this.calculateHours();
        })
      );
    } else {
      this.initNewWorkDay();
    }
  }

  ngOnDestroy(): void {
    this.subs.forEach((x) => {
      x.unsubscribe();
    });
  }

  cancel() {
    return this.modalCtrl.dismiss(null, 'cancel');
  }

  initNewWorkDay() {
    this.newWorkDay.id = '';
    this.newWorkDay.user = '';
    this.newWorkDay.workEntries = [];
    this.newWorkDay.workEntries.push({
      constructionSite: '',
      timeEntries: [{}],
      description: '',
      workingDateUtc: null,
      approvedBy: null,
      createdBy: this.state.userName,
      approvedDateUtc: null,
    });
    this.newWorkDay.workingDate = null;
    if (!this.state.userHasMinType(1)) {
      this.workers.push(this.state.userName.toLowerCase());
    }
  }

  getSelectedConSiteIds(): string[] {
    return this.newWorkDay.workEntries.map((x) => x.constructionSite);
  }

  addTimeEntry(workEntry: WorkingEntry) {
    if (workEntry.timeEntries.length == 0) {
      workEntry.timeEntries.push({});

      return;
    }
    const lastValue = workEntry.timeEntries[workEntry.timeEntries.length - 1];
    const start = this.tools.addOneHour(lastValue.end);
    workEntry.timeEntries.push({
      start: start,
      end: this.tools.addOneHour(start),
    });
  }

  removeTimeEntry(entries: TimeEntry[], i: number) {
    entries.splice(i, 1);
  }

  userChange(e: any) {
    if (this.workDayId) {
      this.newWorkDay.user = e;
    } else {
      this.workers = e;
    }
    this.usersWithExistingWorkDays = this.state.getExistingWorkDays(
      this.workDayId,
      this.workDayId ? [this.newWorkDay.user] : this.workers,
      this.newWorkDay.workingDate
    );
  }

  conSiteChange(conSiteId: string, workEntry: WorkingEntry) {
    workEntry.constructionSite = conSiteId;
  }

  removeConSite(workEntry: WorkingEntry) {
    this.newWorkDay.workEntries = this.newWorkDay.workEntries.filter(
      (x) => x !== workEntry
    );
    this.calculateHours();
  }

  loadConstructionSites() {
    this.state.conSites$.subscribe((x) => {
      this.conSites = x;
    });
  }

  async createTimeEntry() {
    if (!this.inputsValid()) return;
    await this.modalCtrl.dismiss(null, 'confirm');
    this.state.addWorkDay(this.newWorkDay, this.workers);
  }

  async updateTimeEntry() {
    if (!this.inputsValid()) return;
    await this.modalCtrl.dismiss(null, 'confirm');
    this.state.updateWorkDay(this.newWorkDay);
  }

  addWorkEntry() {
    this.newWorkDay.workEntries.push({
      constructionSite: '',
      timeEntries: [{}],
      description: '',
      createdBy: this.state.userName,
      workingDateUtc: null,
    });
  }

  isAnyApproved(): boolean {
    return this.newWorkDay.workEntries.find((x) => x.approvedBy) != null;
  }

  inputsValid(): boolean {
    let valid = true;
    if (!this.workDayId && this.workers?.length == 0) valid = false;
    if (this.newWorkDay.workEntries?.length == 0) valid = false;
    this.newWorkDay.workEntries?.forEach((x) => {
      if (x.timeEntries?.length == 0) valid = false;
      if (x.constructionSite == '') valid = false;
      if (this.tools.arrayHasOverlap(x.timeEntries)) valid = false;
    });
    if (this.usersWithExistingWorkDays.length > 0) valid = false;

    return valid;
    /*if (this.newWorkDay.user == '')
      this.state.showErrorToast('Bitte Mitarbeiter auswählen');
    if (this.newWorkDay.constructionSite == '')
      this.state.showErrorToast('Bitte Baustelle auswählen');
    if (this.newWorkDay.timeEntries.length == 0)
      this.state.showErrorToast('Bitte Arbeitszeit eintragen');
    if (
      this.newWorkDay.worker == '' ||
      this.newWorkDay.constructionSite == '' ||
      this.newWorkDay.timeEntries.length == 0
    )
      return false;*/
  }

  loadTimeEntries() {}

  timeEntryStartChanged(entry: TimeEntry, evt: string) {
    entry.start = evt;
    this.calculateHours();
  }

  timeEntryEndChanged(entry: TimeEntry, evt: string) {
    entry.end = evt;
    this.calculateHours();
  }

  calculateHours() {
    let timeEntries: TimeEntry[] = [];
    this.newWorkDay.workEntries.forEach((w) => {
      timeEntries.push(...w.timeEntries);
    });
    this.fullDayWorked = this.tools.calculateHours(timeEntries);
  }

  workDayDateChanged(evt: string) {
    this.newWorkDay.workingDate = evt;
    this.usersWithExistingWorkDays = this.state.getExistingWorkDays(
      this.workDayId,
      this.workDayId ? [this.newWorkDay.user] : this.workers,
      this.newWorkDay.workingDate
    );
  }
}
